"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.blockchainBaseURL = exports.getCurrencyExplorer = exports.hasCurrencyExplorer = exports.findCurrencyExplorer = void 0;
var invariant_1 = __importDefault(require("invariant"));
var env_1 = require("../env");
var explorerConfig_1 = require("./explorerConfig");
var findCurrencyExplorer = function (currency) {
    var config = (0, explorerConfig_1.getExplorerConfig)()[currency.id];
    if (!config)
        return;
    var id = config.id;
    if ((0, env_1.getEnv)("SATSTACK") && currency.id === "bitcoin") {
        return {
            endpoint: (0, env_1.getEnv)("EXPLORER_SATSTACK"),
            id: "btc",
            version: "v3"
        };
    }
    if (config.experimental && (0, env_1.getEnv)("EXPERIMENTAL_EXPLORERS")) {
        var base_1 = config.experimental.base;
        var version_1 = config.experimental.version;
        var CURRENCIES_JS = (0, env_1.getEnv)("EXPERIMENTAL_CURRENCIES_JS_BRIDGE");
        var useJS = false;
        if (CURRENCIES_JS) {
            useJS = CURRENCIES_JS.split(",").includes(currency.id);
        }
        //V2 explorer for doge and bitcoin cash when libcore is used
        if ((currency.id === "bitcoin_cash" || currency.id === "doge") && !useJS) {
            version_1 = "v2";
        }
        return {
            endpoint: (0, env_1.getEnv)(base_1),
            id: id,
            version: version_1
        };
    }
    var _a = config.stable, base = _a.base, version = _a.version;
    return {
        endpoint: (0, env_1.getEnv)(base),
        id: id,
        version: version
    };
};
exports.findCurrencyExplorer = findCurrencyExplorer;
var hasCurrencyExplorer = function (currency) {
    return !!(0, exports.findCurrencyExplorer)(currency);
};
exports.hasCurrencyExplorer = hasCurrencyExplorer;
var getCurrencyExplorer = function (currency) {
    var res = (0, exports.findCurrencyExplorer)(currency);
    (0, invariant_1["default"])(res, "no Ledger explorer for ".concat(currency.id));
    return res;
};
exports.getCurrencyExplorer = getCurrencyExplorer;
var blockchainBaseURL = function (currency) {
    var _a = (0, exports.getCurrencyExplorer)(currency), id = _a.id, version = _a.version, endpoint = _a.endpoint;
    return "".concat(endpoint, "/blockchain/").concat(version, "/").concat(id);
};
exports.blockchainBaseURL = blockchainBaseURL;
//# sourceMappingURL=Ledger.js.map